import { ChevronRightIcon, CopyIcon } from 'lucide-react'

import { Badge } from '@/components/lemmala-design-system/badge/badge'
import { Button } from '@/components/lemmala-design-system/button/button'
import { Card } from '@/components/lemmala-design-system/card/card'
import { TextWithIcon } from '@/components/lemmala-design-system/text-with-icon/text-with-icon'
import { useToast } from '@/components/lemmala-design-system/toast/use-toast'
import { ATTESTATION_EVIDENCE_LABELS } from '@/components/shared/attestation-evidence/labels'

type AttestationEvidenceProps = {
  notes: string
  onGoToActivity?: () => void
}

export const AttestationEvidence = ({ notes, onGoToActivity }: AttestationEvidenceProps) => {
  const { toast } = useToast()

  const copyNotes = () => {
    navigator.clipboard.writeText(notes)
    toast({ title: ATTESTATION_EVIDENCE_LABELS.quotesCopied, variant: 'success' })
  }

  return (
    <Card className='border-main-border-default'>
      <div className='flex items-center gap-2 border-b border-main-border-default bg-main-background-muted px-3 py-2.5'>
        <Badge variant='neutral' badgeStyle='subtle'>
          {ATTESTATION_EVIDENCE_LABELS.attestation}
        </Badge>
        {onGoToActivity && (
          <Button variant='link' size='sm' onClick={onGoToActivity}>
            <TextWithIcon
              text={ATTESTATION_EVIDENCE_LABELS.goToActivity}
              icon={<ChevronRightIcon className='size-4' />}
              iconPosition='end'
            />
          </Button>
        )}
        <Button
          variant='text'
          size='sm'
          className='ml-auto text-main-foreground-tertiary'
          onClick={copyNotes}
        >
          <TextWithIcon
            text={ATTESTATION_EVIDENCE_LABELS.copyQuotes}
            icon={<CopyIcon className='size-3' strokeWidth={1.5} />}
          />
        </Button>
      </div>
      <div className='p-3 text-main-foreground-primary text-body-default'>{notes}</div>
    </Card>
  )
}
